const APAgreementContent = () => {
  return (
    <>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
        laboris nisi ut aliquip ex ea commodo consequat (&#34;AP Agreement&#34;).
      </p>
      <p>
        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
        mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem
        accusantium doloremque laudantium.
      </p>
      <p>
        Totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae
        vitae dicta sunt explicabo referred to as &#34;you.&#34;
      </p>
      <div id="institution">
        <h3>Institution</h3>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.
        </p>
        <p>
          In ordering and administering AP exams, Institution is bound by the additional terms found
          within the{' '}
          <a href="https://example.com/manual-part1" target="_blank" rel="noopener noreferrer">
            Coordinator's Manual Part 1<span className="sr-only"> (opens in new window)</span>
          </a>{' '}
          and the{' '}
          <a href="https://example.com/manual-part2" target="_blank" rel="noopener noreferrer">
            Coordinator's Manual Part 2<span className="sr-only"> (opens in new window)</span>
          </a>
          .
        </p>
        <p>
          Risus commodo viverra maecenas accumsan lacus vel facilisis. Nulla posuere sollicitudin
          aliquam ultrices sagittis orci a scelerisque purus semper.
        </p>
        <p>
          Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis
          egestas. Proin sagittis nisl rhoncus mattis rhoncus urna neque viverra justo nec ultrices
          dui sapien eget mi proin sed (&#34;PII&#34;).
        </p>
        <p>
          Magna fringilla urna porttitor rhoncus dolor purus non enim praesent elementum facilisis
          leo vel fringilla est ullamcorper eget nulla.
        </p>
        <p>
          Facilisi nullam vehicula ipsum a arcu cursus vitae congue mauris rhoncus aenean vel elit
          scelerisque mauris pellentesque pulvinar pellentesque habitant morbi.
        </p>
      </div>
      <div id="participants">
        <h3>Participants</h3>
        <p>
          Nunc sed velit dignissim sodales ut eu sem integer vitae justo eget magna fermentum
          iaculis eu non diam phasellus vestibulum lorem sed risus ultricies tristique nulla aliquet
          enim tortor at auctor urna nunc id cursus.
        </p>
        <p>
          Adipiscing bibendum est ultricies integer quis auctor elit sed vulputate mi sit amet
          mauris commodo quis imperdiet massa tincidunt nunc pulvinar sapien et ligula ullamcorper.
        </p>
      </div>
      <div id="administrators">
        <h3>Administrators</h3>
        <p>
          Viverra maecenas accumsan lacus vel facilisis volutpat est velit egestas dui id ornare
          arcu odio ut sem nulla pharetra diam sit amet nisl suscipit adipiscing bibendum.
        </p>
        <p>Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque habitant morbi:</p>
        <ul>
          <li>
            Turpis egestas maecenas pharetra convallis posuere morbi leo urna molestie at elementum
            eu facilisis sed odio morbi quis commodo odio aenean;
          </li>
          <li>
            Sed elementum tempus egestas sed sed risus pretium quam vulputate dignissim suspendisse
            in est ante in nibh mauris;
          </li>
          <li>
            Cursus mattis molestie a iaculis at erat pellentesque adipiscing commodo elit at
            imperdiet dui accumsan; and
          </li>
          <li>
            Arcu cursus euismod quis viverra nibh cras pulvinar mattis nunc sed blandit libero
            volutpat.
          </li>
        </ul>
        <p>Facilisi cras fermentum odio eu feugiat pretium nibh ipsum consequat nisl:</p>
        <ul>
          <li>
            Vel fringilla est ullamcorper eget nulla facilisi etiam dignissim diam quis enim
            lobortis scelerisque;
          </li>
          <li>
            Fermentum leo vel orci porta non pulvinar neque laoreet suspendisse interdum consectetur
            libero id faucibus nisl;
          </li>
          <li>
            Tincidunt nunc pulvinar sapien et ligula ullamcorper malesuada proin libero nunc
            consequat interdum varius sit amet;
          </li>
          <li>
            Mattis enim ut tellus elementum sagittis vitae et leo duis ut diam quam nulla porttitor;
          </li>
          <li>
            Massa eget egestas purus viverra accumsan in nisl nisi scelerisque eu ultrices vitae
            auctor eu augue; and
          </li>
          <li>
            Ut sem viverra aliquet eget sit amet tellus cras adipiscing enim eu turpis egestas.
          </li>
        </ul>
        <p>
          Porta nibh venenatis cras sed felis eget velit aliquet sagittis id consectetur purus ut
          faucibus pulvinar elementum integer enim neque volutpat ac tincidunt.
        </p>
        <p>
          Vivamus arcu felis bibendum ut tristique et egestas quis ipsum suspendisse ultrices
          gravida dictum fusce ut placerat orci nulla pellentesque dignissim enim sit amet venenatis
          urna.
        </p>
      </div>
    </>
  )
}

export default APAgreementContent
